"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var actionTypes_1 = require("../actionTypes");

var modelUtils_1 = require("../../utils/modelUtils");

exports.paymentOptionsReducer = function (state, action) {
  if (state === void 0) {
    state = {
      loaded: false,
      values: []
    };
  }

  switch (action.type) {
    case actionTypes_1.LOAD_PAYMENT_OPTIONS:
      return __assign(__assign({}, state), {
        values: __spreadArrays(action.data),
        loaded: true
      });

    case actionTypes_1.LOAD_PAYMENT_OPTION:
    case actionTypes_1.UPDATE_PAYMENT_OPTION:
      var values = __spreadArrays(state.values);

      var index = values.findIndex(function (_a) {
        var id = _a.id;
        return id == action.data.id;
      });

      if (index === -1) {
        values.push(action.data);
      } else {
        values[index] = action.data;
      }

      return __assign(__assign({}, state), {
        values: values
      });

    case actionTypes_1.CREATE_PAYMENT_OPTION:
      return __assign(__assign({}, state), {
        values: __spreadArrays(state.values, [action.data])
      });

    case actionTypes_1.ADD_PAYMENT_OPTION_PERMISSION:
      return __assign(__assign({}, state), {
        values: modelUtils_1.addModelPermission(state.values, action)
      });

    case actionTypes_1.SET_PAYMENT_OPTION_ACCESSIBILITY:
      return __assign(__assign({}, state), {
        values: state.values.map(function (p) {
          if (p.id === action.id) {
            p.accessibility = action.data;
          }

          return p;
        })
      });

    default:
      return __assign({}, state);
  }
};